import React from 'react';
import { Star, ExternalLink, MessageSquare } from 'lucide-react';

const GoogleReviews = ({ variant = 'full' }) => {
  const googleBusinessUrl = 'https://share.google/R1GlWWnERVrJWFsuR';
  const reviewUrl = `${googleBusinessUrl}?reviewId=write`;

  // Kompakte Variante für Header/Footer
  if (variant === 'compact') {
    return (
      <div className="flex items-center gap-3">
        <a
          href={googleBusinessUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-sm hover:text-orange-600 transition-colors"
        >
          <div className="flex items-center gap-1">
            {[1, 2, 3, 4, 5].map((star) => (
              <Star key={star} className="w-4 h-4 fill-orange-500 text-orange-500" />
            ))}
          </div>
          <span className="font-semibold">4.9/5</span>
          <span className="text-gray-600">(Google Bewertungen)</span>
        </a>
      </div>
    );
  }

  // CTA Button Variante
  if (variant === 'cta') {
    return (
      <a
        href={reviewUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full font-semibold transition-all shadow-md hover:shadow-lg"
      >
        <MessageSquare className="w-5 h-5" />
        Bewertung schreiben
      </a>
    );
  }

  // Volle Widget-Variante
  return (
    <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-200">
      <div className="flex items-start justify-between mb-6">
        <div>
          <h3 className="text-2xl font-bold text-gray-900 mb-2">
            Bewertungen bei Google
          </h3>
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star key={star} className="w-6 h-6 fill-orange-500 text-orange-500" />
              ))}
            </div>
            <span className="text-3xl font-bold text-gray-900">4.9</span>
            <span className="text-gray-600">von 5</span>
          </div>
          <p className="text-sm text-gray-600 mt-2">
            Basierend auf Google Bewertungen
          </p>
        </div>
        <img
          src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_74x24dp.png"
          alt="Google"
          className="h-8"
        />
      </div>

      <div className="space-y-4 mb-6">
        {/* Beispiel-Bewertungen */}
        <div className="border-l-4 border-orange-500 pl-4 py-2">
          <div className="flex items-center gap-2 mb-2">
            <div className="flex items-center gap-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star key={star} className="w-4 h-4 fill-orange-500 text-orange-500" />
              ))}
            </div>
            <span className="text-sm font-semibold">5/5</span>
          </div>
          <p className="text-gray-700 text-sm italic">
            "Schnell, professionell und fair. Genau so sollte ein Schlüsseldienst sein!"
          </p>
          <p className="text-xs text-gray-500 mt-1">- Kunde aus Dortmund</p>
        </div>

        <div className="border-l-4 border-orange-500 pl-4 py-2">
          <div className="flex items-center gap-2 mb-2">
            <div className="flex items-center gap-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star key={star} className="w-4 h-4 fill-orange-500 text-orange-500" />
              ))}
            </div>
            <span className="text-sm font-semibold">5/5</span>
          </div>
          <p className="text-gray-700 text-sm italic">
            "Transparente Preise am Telefon, schnelle Anfahrt. Sehr empfehlenswert!"
          </p>
          <p className="text-xs text-gray-500 mt-1">- Kundin aus Dortmund</p>
        </div>

        <div className="border-l-4 border-orange-500 pl-4 py-2">
          <div className="flex items-center gap-2 mb-2">
            <div className="flex items-center gap-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star key={star} className="w-4 h-4 fill-orange-500 text-orange-500" />
              ))}
            </div>
            <span className="text-sm font-semibold">5/5</span>
          </div>
          <p className="text-gray-700 text-sm italic">
            "Tür ohne Schaden geöffnet und fairer Festpreis. Top Service!"
          </p>
          <p className="text-xs text-gray-500 mt-1">- Kunde aus Dortmund</p>
        </div>
      </div>

      <div className="flex flex-wrap gap-3 pt-4 border-t border-gray-200">
        <a
          href={googleBusinessUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 inline-flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-900 px-6 py-3 rounded-full font-semibold transition-all"
        >
          <ExternalLink className="w-5 h-5" />
          Alle Bewertungen ansehen
        </a>
        <a
          href={reviewUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 inline-flex items-center justify-center gap-2 bg-orange-600 hover:bg-orange-700 text-white px-6 py-3 rounded-full font-semibold transition-all shadow-md hover:shadow-lg"
        >
          <MessageSquare className="w-5 h-5" />
          Bewertung schreiben
        </a>
      </div>

      <p className="text-xs text-gray-500 text-center mt-4">
        Ihre Meinung ist uns wichtig! Teilen Sie Ihre Erfahrung mit anderen Kunden.
      </p>
    </div>
  );
};

export default GoogleReviews;
